import { FC } from 'react';
import { Entry, GroupedData } from '../services/DataService';
import CustomList from './CustomList';

type ChecklistProps = {
    filtered: boolean;
    data: GroupedData;
    onClick: (id: number, selected: boolean) => void;
};

const filterList = (data: Entry[]) => {
    const unchecked = (row: Entry) => !row.selected;
    return data.filter(unchecked);
};

const Checklist: FC<ChecklistProps> = ({ filtered, data, onClick }) => {
    return (
        <>
            {Object.keys(data).map((key) => {
                const list = data[key];
                return (
                    <CustomList
                        key={key}
                        title={key}
                        data={filtered ? filterList(list) : list}
                        onClick={onClick}
                    />
                );
            })}
        </>
    );
};

export default Checklist;
